import api from "crqlar-react-common/dist/services/api";

/**
 * A till's session, returned by the unauthenticated device-key exchange.
 * Mirrors `PosSessionResponseDTO` in `crqlar-api-v3`.
 */
export interface PosSession {
    token: string;
    expiresInSeconds: number;
    organizationId: string;
    organizationName?: string;
    deviceId: string;
    deviceName?: string;
    sectorId?: string;
    rvcRef?: string;
    /** Dashboard path this till should open, e.g. one restaurant's floor plan. */
    landingPath?: string;
}

/**
 * Exchanges a POS device key for a crqlar session.
 *
 * The endpoint is unauthenticated — the key is the credential — and answers every failure with the
 * same `401`, so there is nothing here to branch on beyond success.
 */
export async function exchangePosDeviceKey(key: string, workstation?: string): Promise<PosSession> {
    const response = await api.post<PosSession>("/v3/public/pos/session", {key, workstation});
    return response.data;
}

/**
 * Guards a redirect target. The server already refuses to store an absolute URL as a landing path;
 * this repeats the check on whatever actually arrives, because a till follows it without anyone
 * reading the address bar.
 *
 * Kept in step with `PosLandingPath` in `crqlar-api-v3`.
 */
export function isSafePosLandingPath(path: string | undefined | null): boolean {
    if (!path) return false;

    const trimmed = path.trim();
    if (!trimmed.startsWith("/")) return false;
    // A browser reads "//host" as an absolute URL, not as a path.
    if (trimmed.startsWith("//")) return false;
    if (trimmed.includes("\\")) return false;
    if (trimmed.includes("://")) return false;
    return true;
}
